// basicPlus is sold as "Creator"; `basic` is the retired legacy tier.
// `fullLabel` is the name shown where plans are managed or compared (Account, Pricing).
const PLAN_LABELS = {
  free: { label: 'Free', fullLabel: 'Basic · Free', paid: false },
  basic: { label: 'Basic', paid: true },
  basicPlus: { label: 'Creator', paid: true },
  pro: { label: 'Pro', paid: true }
}

export const getPlanLabel = (planId, { full = false } = {}) => {
  const plan = PLAN_LABELS[planId]
  if (!plan) return null
  return { label: (full && plan.fullLabel) || plan.label, paid: plan.paid }
}
